<template>
  <section>
    <!-- search -->
    <form @submit.prevent="loadData">
      <div class="section_search">
        <div class="tray">
          <div class="row">
            <div class="cell">
              <select
                class="selectBox"
                style="display:inline-block;width:100px;"
                v-model="formData.range"
              >
                <option value="DAILY">일간</option>
                <option value="WEEKLY">주간</option>
                <option value="MONTHLY">월간</option>
                <option value="YEARLY">년간</option>
              </select>

              <!-- 일간 -->
              <DatePicker
                v-if="formData.range === 'DAILY'"
                :value="$utils.calcDate(null, '-1d')"
                class="blank"
                ref="picker"
                :maxDate="new Date()"
              />
              <WeekPicker
                v-if="formData.range === 'WEEKLY'"
                class="blank"
                width="300px"
                ref="picker"
                :value="$utils.calcDate(new Date(), '-1w')"
                :maxDate="new Date()"
              />
              <MonthPicker
                v-if="formData.range === 'MONTHLY'"
                class="blank"
                ref="picker"
                :maxDate="new Date()"
              />
              <YearPicker
                v-if="formData.range === 'YEARLY'"
                class="blank"
                ref="picker"
                minDate="2017"
                :maxDate="new Date()"
              />
            </div>
            <span class="label">지역</span>
            <div class="cell">
              <GroupSelector permissionCode="statistic" :useGroup="false" ref="groupSelector" />
              <button type="submit" class="btn_search">검색</button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- //search -->

    <div v-if="res" ref="tableWrap">
      <h4 class="section_title">
        <span class="ico"></span>
        두뇌톡톡 게임유형별
      </h4>
      <TypeTable :itemArray="res.gameContentTypeStatList" />

      <h4 class="section_title">
        <span class="ico"></span>
        두뇌톡톡 완료일수별 누적통계 (최근 6개월, 조회기간 무관)
      </h4>
      <PeriodTable :itemArray="res.gameContentPeriodStatList" />

      <h4 class="section_title">
        <span class="ico"></span>
        평균점수 누적통계 (최근 6개월, 조회기간 무관)
      </h4>
      <AverageTable :itemArray="[res.gameContentAvgCount]" />
    </div>

    <div class="section_button none_paginate">
      <ExcelDownloadButton
        v-if="res"
        :filename="$utils.excelName('두뇌톡톡', '콘텐츠통계')"
        :tablesContainer="$refs.tableWrap"
      />
      <HelpButton contentId="HELP_04" />
    </div>
  </section>
</template>

<script>
import TypeTable from "./Table.Type";
import PeriodTable from "./Table.Period";
import AverageTable from "./Table.Average";

export default {
  components: { TypeTable, PeriodTable, AverageTable },
  data() {
    return {
      res: null,
      resPeriod: "",
      formData: {
        range: "WEEKLY",
        state: "",
        city: ""
      }
    };
  },
  computed: {},
  methods: {
    loadData() {
      const options = this.requestOptions();
      this.$axios
        .get("/admin/happy/stats/v2/game/content", options)
        .then(({ data }) => {
          this.res = data;
        });
    },
    requestOptions() {
      const group = this.$refs.groupSelector.getData();
      const startDate = this.$refs.picker.getDate();

      return {
        params: _.merge(this.formData, {
          searchDate: this.$utils.dateText(startDate),
          orgCode: group.orgId,
          state: group.stateId,
          city: group.cityId
        })
      };
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
